(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hz-tabbed-new-products"] && !Shopify.designMode) return;
  try {
    
  /* Egyedi név: a régi 'hz-product-tabs' komponenssel soha nem ütközik. */
  if (!customElements.get('hz-tcg-news-v3')) {
    class HzTcgNewsV3 extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[role="tab"][data-tab]'));
        this.dropdown = this.querySelector('[data-hz-dropdown]');
        this.summary = this.dropdown?.querySelector('summary');
        this.current = this.querySelector('[data-hz-current]');
        this.options = Array.from(this.querySelectorAll('[data-hz-option]'));
        if (!this.panels.length) return;

        this._click = (event) => {
          const option = event.target.closest('[data-hz-option]');
          if (option && this.contains(option)) {
            const target = this.panels.find((p) => p.dataset.panel === option.dataset.targetPanel);
            if (target) {
              event.preventDefault();  // fallback href megmarad, ha a JS nem fut
              this.activatePanel(option.dataset.targetPanel);
              if (this.dropdown) this.dropdown.open = false;
              if (event.detail === 0) this.summary?.focus();
            }
            return;
          }

          const tab = event.target.closest('[role="tab"][data-tab]');
          if (tab && this.tabs.includes(tab)) this.activatePanel(tab.dataset.tab);
        };

        this._keydown = (event) => {
          if (event.key === 'Escape' && this.dropdown?.open) {
            event.preventDefault();
            this.dropdown.open = false;
            this.summary?.focus();
            return;
          }

          const option = event.target.closest('[data-hz-option]');
          if (option && this.options.includes(option)) {
            const index = this.options.indexOf(option);
            let next = index;
            if (event.key === 'ArrowDown') next = (index + 1) % this.options.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + this.options.length) % this.options.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.options.length - 1;
            else return;
            event.preventDefault();
            this.options[next].focus();
            return;
          }

          const tab = event.target.closest('[role="tab"][data-tab]');
          if (!tab || !this.tabs.includes(tab)) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.tabs.indexOf(tab);
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.activatePanel(this.tabs[next].dataset.tab, true);
        };

        this._outsidePointer = (event) => {
          if (this.dropdown?.open && !this.dropdown.contains(event.target)) {
            this.dropdown.open = false;
          }
        };
        this.addEventListener('click', this._click);
        this.addEventListener('keydown', this._keydown);
        document.addEventListener('pointerdown', this._outsidePointer);
        const initialPanel = this.panels.find((p) => !p.hidden) || this.panels[0];
        if (initialPanel) this.activatePanel(initialPanel.dataset.panel);
      }

      disconnectedCallback() {
        if (this._click) this.removeEventListener('click', this._click);
        if (this._keydown) this.removeEventListener('keydown', this._keydown);
        if (this._outsidePointer) document.removeEventListener('pointerdown', this._outsidePointer);
        this._initialized = false;
      }

      activatePanel(key, moveFocus = false) {
        const selected = this.panels.find((p) => p.dataset.panel === key);
        if (!selected) return;
        this.panels.forEach((panel) => {
          const active = panel === selected;
          panel.hidden = !active;
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          panel.classList.toggle('is-active', active);
        });
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        this.options.forEach((option) => {
          const active = option.dataset.targetPanel === key;
          option.classList.toggle('is-active', active);
          if (active) option.setAttribute('aria-current', 'true');
          else option.removeAttribute('aria-current');
          if (active && this.current) this.current.textContent = option.textContent.trim();
        });
        this.prepareActivePanel(selected);
      }

      prepareActivePanel(panel) {
        const images = Array.from(panel.querySelectorAll('img'));
        const slides = Array.from(panel.querySelectorAll('slideshow-slide, .card-gallery, .product-card'));
        slides.forEach((element) => { element.style.contentVisibility = 'visible'; });
        images.forEach((image) => {
          image.loading = 'eager';
          image.setAttribute('loading', 'eager');
          image.decoding = 'async';
          image.style.contentVisibility = 'visible';
          image.style.backfaceVisibility = 'hidden';
          image.style.transform = 'translateZ(0)';
          if (image.complete && typeof image.decode === 'function') image.decode().catch(() => {});
        });
        void panel.offsetHeight;
        requestAnimationFrame(() => {
          if (!panel.isConnected || panel.hidden) return;
          requestAnimationFrame(() => {
            if (!panel.isConnected || panel.hidden) return;
            panel.classList.add('is-rendered');
            window.dispatchEvent(new Event('resize'));
            images.forEach((image) => {
              image.style.transform = 'translateZ(0.001px)';
              requestAnimationFrame(() => { image.style.transform = 'translateZ(0)'; });
            });
          });
        });
      }
    }
    customElements.define('hz-tcg-news-v3', HzTcgNewsV3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
